import { delay } from './delay';

export const closeBrowserWindow = async () => {
  await delay(1000);
  close();
};
